'use client';

import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { toSearchParams } from '@/app/lib/schemas/types/transformers';
import { updateSearchParams } from '@/app/lib/store/search-params-slice';
import { useAppDispatch } from '@/app/lib/store/hooks';

interface Props {
  children: React.ReactNode;
}

export default function SearchParamsProvider({ children }: Props) {
  const searchParams = useSearchParams();

  const page = searchParams.get('page') || '1';
  const query = searchParams.get('query') || '';
  const levels = searchParams.getAll('levels');

  const dispatch = useAppDispatch();

  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      const sp = toSearchParams({ query, levels: levels ? levels : [], page });
      dispatch(updateSearchParams(sp));
      isFirstLoad.current = false;
    }
  }, [dispatch, query, levels, page]);

  return <>{children}</>;
}
